
import { getMessaging, getFirebaseConfig } from './firebase-messaging.js';

/**
 * Request notification permission and get token if granted
 */
export function requestNotificationPermission(registration) {
	Notification.requestPermission()
		.then((permission) => {
			if (permission === 'granted') {
				getFCMToken(registration);
			} else if (permission === 'denied') {
				console.warn('Notification permission denied');
			}

			const event = new CustomEvent('notification-permission-changed');
			document.dispatchEvent(event);
		})
		.catch((error) => {
			console.error('Error requesting permission:', error);
		});
}

/**
 * Get FCM Token
 */
export function getFCMToken(registration) {
	const messaging = getMessaging();
	const firebaseConfig = getFirebaseConfig();

	if (!messaging || !firebaseConfig) return;

	const vapidKey = firebaseConfig.vapidKey;

	messaging.getToken({ vapidKey, serviceWorkerRegistration: registration })
		.then((currentToken) => {
			if (currentToken) {
				saveTokenToServer(currentToken);
			} else {
				console.warn('No FCM token available');
			}
		})
		.catch(async (error) => {
			if (error.message.includes('push service error') || error.name === 'AbortError') {
				try {
					const { showPushServiceErrorInstructions } = await import('./fcm-modal.js');
					showPushServiceErrorInstructions();
				} catch (e) {
					console.error('[FCM Debug] Failed to import fcm-modal.js', e);
				}
			} else {
				console.error('Error getting FCM token:', error);
			}
		});
}

/**
 * Save FCM token to server
 */
function saveTokenToServer(token) {
	fetch('/wp-json/wpcore/v1/fcm/token', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-WP-Nonce': wpcore.rest_nonce
		},
		body: JSON.stringify({ token: token })
	})
		.then(response => response.json())
		.catch(error => {
			console.error('[permissions.js] Token save failed:', error);
		});
}
